import { ChangeDetectorRef, Component, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FeatureMock } from './DataStore/Mock/feature-mock';
import { PageMock } from './DataStore/Mock/page-mock';
import { WebobjectMock } from './DataStore/Mock/webobject-mock';
import { webobjecttypeMock } from './DataStore/Mock/webobjecttype-mock';
import { StepMock } from './DataStore/Mock/step-mock';
import { ScenarioMock } from './DataStore/Mock/scenario-mock';
import { ActionMocks } from './DataStore/Mock/action-mocks';
import { KeywordMocks } from './DataStore/Mock/keyword-mocks';
import { SuserMocks } from './DataStore/Mock/suser-mocks';
import { ListInterface } from './Inteface/list-interface';
import { ScreenService } from './Services/screen.service';
import { ScreenStore } from './DataStore/App/screen-store';
import { ScreenModel } from './Models/screen-model';
import { SuiteMock } from './DataStore/Mock/suite-mock';
import { CTVMock } from './DataStore/Mock/ctvmock';
import { ReportMock } from './DataStore/Mock/report-mock';
import { Router, NavigationEnd } from '@angular/router';
import { SharedService } from './Services/shared.service';
import { WebsocketService } from './Services/websocket.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { GlobalDragStateService } from './Services/global-drag-state.service';
import { Subscription } from 'rxjs';
import { getBrand } from '../environments/brand';

@Component({
  selector: 'ze-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnDestroy {
  title = 'zero';
  showHeader: boolean = true
  list: ListInterface;
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  displayProgressSpinner = false;
  spinnerWithoutBackdrop = false;
  formConfig = [];
  isDragging = false;
  private dragSubscription: Subscription;
  constructor(
    private screenService: ScreenService,
    private router: Router,
    private _sharedService: SharedService,
    private ref: ChangeDetectorRef,
    private titleService: Title,
    private globalDragState: GlobalDragStateService,
  ) {
    // let user = { "token": "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpblR5cGUiOiJJTlRFTExJSl9FWFRFTlNJT04iLCJzdWIiOiJjaGFuZHJhIiwiaWF0IjoxNzY1NzgzMDYwLCJleHAiOjU2OTQxMzc4MzA2MH0.0dcrp9jjTP0H4SrWkBFVYE0xdkFLsZ-AcU2e-YMZ6ukg3A3hoTbe_EU0_5pGezaQY_o_2gf4gyj_pgL-tOzogg" };
    // if (localStorage.getItem('currentUser') == undefined
    //   && localStorage.getItem('currentUser') == null) {
    //   localStorage.setItem('currentUser', JSON.stringify(user));
    //   localStorage.setItem('username', "chandra");
    //   localStorage.setItem('isMapped', undefined);
    //   localStorage.setItem('mapped', undefined);
    //   localStorage.setItem('projectId', "657c82edcd89c01304094e07");
    //   localStorage.setItem('projectIdDb2', "657c82edcd89c01304094e06");
    //   localStorage.setItem("projectName", "HarshalTrail");
    // }
    FeatureMock.initMocks();
    PageMock.initMocks();
    webobjecttypeMock.initMocks();
    WebobjectMock.initMocks();
    ScenarioMock.initMocks();
    StepMock.initMocks();
    ActionMocks.initMocks();
    KeywordMocks.initMocks();
    SuserMocks.initMocks();
    ScreenStore.initMocks();
    SuiteMock.initMocks();
    ReportMock.initMocks();
    CTVMock.initMocks();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const path = this.router.url;
        this.setTitleBasedOnRoute(path);
      });

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {

        if (
          val.urlAfterRedirects.includes('/log') ||
          val.urlAfterRedirects.includes('/login') ||
          val.urlAfterRedirects.includes('/forgot-password') ||
          val.urlAfterRedirects.includes('/update-password') ||
          val.urlAfterRedirects.includes('/xpeer-guide') ||
          val.urlAfterRedirects.includes('/generate-test-case')
        )
          this.showHeader = false;
        else
          this.showHeader = true;
      }
    });
  }
  // webSocketAPI: WebsocketService;
  // greeting: any;
  // name: string;
  ngOnInit(): void {
    this.list = new ListInterface();
    this.list.listItemHeadingProperyName = "name";
    this.list.models = this.screenService.getItems();
    this.list.onClick = this.selectScreen;
    this._sharedService.loaderHide.subscribe(data => {
      this.displayProgressSpinner = data;
      this.ref.detectChanges();
    });

    // Subscribe to drag state changes
    this.dragSubscription = this.globalDragState.isDragging$.subscribe(isDragging => {
      this.isDragging = isDragging;
      this.ref.detectChanges();
    });

    // this.webSocketAPI = new WebsocketService(new AppComponent(this.screenService, this.router, this._sharedService, this.ref));

  }

  setTitleBasedOnRoute(path: string) {
    const appTitle = getBrand().title;
    if (path.includes('/xpeer-guide')) {
      this.titleService.setTitle(`User Guide - ${appTitle}`);
    } else {
      this.titleService.setTitle(appTitle);
    }
  }

  selectScreen(model: ScreenModel) {
  }

  ngOnDestroy(): void {
    if (this.dragSubscription) {
      this.dragSubscription.unsubscribe();
    }
  }

  // connect(){
  //   this.webSocketAPI._connect();
  // }

  // disconnect(){
  //   this.webSocketAPI._disconnect();
  // }

  // sendMessage(){
  //   this.webSocketAPI._send(this.name);
  // }

  // handleMessage(message){
  //   this.greeting = message;
  // }
}